import React, { ChangeEvent, useState } from "react";
import Modal from "react-modal";
import Swal from "sweetalert2";
import axios from "axios";

//@ts-ignore
import Ico from "images/ico.svg";

type Props = {
  relatorio: {
    id: number;
    motivo_correcao: string;
    status: string;
  };
  statusDescricao: string;
  labelBotao: string;
};

export function BotaoUploadRelatorio({
  relatorio,
  statusDescricao,
  labelBotao,
}: Props) {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [error, setError] = useState<string>();
  const [sending, setSending] = useState<boolean>(false);
  const [file, setFile] = useState<File>();

  const open = () => setIsModalOpen(true);
  const close = () => {
    setError(undefined);
    setSending(false);
    setIsModalOpen(false);
    setFile(undefined);
  };

  const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      setFile(e.target.files[0]);
    }
  };

  const salvar = async () => {
    try {
      if (!file) return;

      setError(undefined);
      setSending(true);

      const formData = new FormData();
      formData.append("salvar_e_enviar", "salvar_e_enviar");
      formData.append("relatorio[id]", relatorio.id.toString());
      formData.append("relatorio[arquivo]", file);

      await axios.put(`/relatorios/${relatorio.id}.json`, formData, {
        headers: {
          Accept: "application/json",
        },
      });

      setSending(false);
      close();
      const msg = "Relatório enviado com sucesso";
      const result = await Swal.fire({
        title: msg,
        allowEscapeKey: false,
        icon: "success",
      });
      window.location.reload();
    } catch (err) {
      console.error(err);
      let mensagem =
        "Houve um erro, e o relatório não pode ser salvo. Por favor, tente novamente";
      const data = (err as any)?.response?.data;
      if (Array.isArray(data)) {
        mensagem = data.join("/n");
      } else if (typeof data == "string") {
        mensagem = data;
      } else if (data?.mensagem) {
        mensagem = data.mensagem;
      }

      setError(mensagem);
      setSending(false);
    }
  };

  return (
    <>
      <button
        type="button"
        className="bt"
        onClick={open}
        id={`relatorio_${relatorio.id}`}
      >
        {labelBotao}
      </button>
      <Modal
        isOpen={isModalOpen}
        onRequestClose={close}
        ariaHideApp={false}
        // style={customStyles}
        className="modal"
      >
        <div className="modal__janela">
          <header className="modal__titulo">
            <h1>Enviar relatório</h1>
            <button className="modal__fechar" onClick={close}>
              {Ico ? (
                <svg className="ico">
                  <use xlinkHref={`${Ico}#fechar`} />
                </svg>
              ) : (
                "x"
              )}
            </button>
          </header>
          <section className="modal__conteudo">
            {!!error && (
              <div className="grid-12">
                <p className="mensagem--correcao">{error}</p>
              </div>
            )}

            <p>
              <strong>Situação: </strong>
              {statusDescricao}
            </p>
            {relatorio.status == "aguardando_correcao_servidor" &&
              !!relatorio.motivo_correcao && (
                <p>
                  <strong>Motivo da correção: </strong>
                  {relatorio.motivo_correcao}
                </p>
              )}
            <div className="container container--form">
              <label className="form grid-12">
                <input
                  type="file"
                  id="arquivo_relatorio"
                  onChange={handleFileChange}
                  accept="application/pdf"
                />
                <span className="form__file-info">
                  <svg className="ico">
                    <use xlinkHref={`${Ico}#upload`} />
                  </svg>{" "}
                  <i>{file ? file.name : "Insira aqui o relatório"}</i>
                </span>
              </label>
            </div>
          </section>
          <footer className="modal__acoes">
            <button className="bt bt--vermelho" type="button" onClick={close}>
              Cancelar
            </button>
            <button
              className="bt"
              type="button"
              onClick={salvar}
              disabled={sending || !file}
            >
              {sending ? "Salvando..." : "Salvar"}
            </button>
          </footer>
        </div>
      </Modal>
    </>
  );
}
